import { useRoutes } from 'react-router-dom';
import Catechism from '../../pages/public/Catechism';
import Committee from '../../pages/public/Committee';
import Forms from '../../pages/public/Forms';
import Services from '../../pages/public/Services';
import LandingPage from '../../pages/public/LandingPage';
import Feed from '../feed/Feed';
import MyAccount from '../../pages/private/MyAccount';
import Admin from '../../pages/private/Admin';
import History from '../../pages/public/History';
import Gallery from '../../pages/public/Gallery';

const Router = () => useRoutes(
  [
    { path: '/', element: <Feed /> },
    { path: 'home', element: <Feed /> },
    { path: 'feed', element: <Feed /> },
    { path: 'myaccount', element: <MyAccount /> },
    { path: 'history', element: <History /> },
    { path: 'gallery', element: <Gallery /> },
    { path: 'committee', element: <Committee /> },
    { path: 'forms', element: <Forms /> },
    { path: 'services', element: <Services /> },
    { path: 'catechism', element: <Catechism /> },
    { path: 'admin', element: <Admin /> },
    { path: '*', element: <LandingPage /> },
  ],
);

export default Router;
